export default "__VITE_ASSET__DbNW0RkV__"